export default __webpack_public_path__ + "static/media/6.c2dded2d.jpg";